const processSubscription = ([subscription], isFreeTrial, t) => {
    let isTimeBound = false; // By default assume subscription
    // TODO -- if there's more than 1 subscription for the product....
    const billKeyToHumanKey = {
        recurring_frequency: t('billing_plan'),
        next_bill_timestamp: t('next_bill_date'),
        amount_cents: t('next_bill_amount'),
        last4_brand: t('payment_type'),
    };
    const currencyToSymbol = {
        "usd": "$",
        "eur": "€",
        "gbp": "£",
        "aud": "$",
        "cad": "$",
        "chf": "CHF ",
        "jpy": "¥",
        "rub": "₽",
        "mxn": "$",
    };
    const isCancelled = subscription.subscription_data.cancelled;
    const frequency = subscription.subscription_data.recurring_frequency;
    const transformer = ({ key, value }) => {
        const newObj = Object.create(null);
        let maybeCurrency = subscription.subscription_data.currency;
        if (maybeCurrency) {
            maybeCurrency = maybeCurrency.toLowerCase();
        }
        let maybeCurrencySymbol = "";
        if (maybeCurrency && currencyToSymbol[maybeCurrency]) {
            maybeCurrencySymbol = currencyToSymbol[maybeCurrency]
            if (maybeCurrencySymbol === null || typeof maybeCurrencySymbol === "undefined") {
                maybeCurrencySymbol = "";
            }
        }
        newObj["key"] = billKeyToHumanKey[key];
        switch (key) {
            case "next_bill_timestamp":
                newObj["value"] = new Date(value).toLocaleDateString("process.env.APP_LOCALE".replace('_', '-'));
                break;
            case "amount_cents":
                newObj["value"] = maybeCurrencySymbol + (value / 100).toFixed(2);
                break;
            case "last4_brand":
                let last4_brand = subscription.subscription_data.last4_brand;
                try {
                    const processor = subscription.subscription_data.processor || "";
                    const isPaddle = processor.toLowerCase() === "paddle";
                    last4_brand = isPaddle ? "Paddle" : last4_brand;
                } catch(error) {
                    console.log(`Error setting payment method. ERR = ${error}`);
                }
                newObj["value"] = last4_brand;
                break;
            default:
                newObj["value"] = value;
                break;
        }
        return newObj;
    };
    let fmtBillFrequency = "";
    let nextBillString = "";
    if (frequency) {
        if (frequency.toLowerCase() === "yearly") {
            fmtBillFrequency = t('yearly', {"$replace$": ""}).trim();
        } else {
            fmtBillFrequency = t('monthly', {"$replace$": ""}).trim();
        }
    }
    let nextBillDate = new Date(subscription.subscription_data.next_bill_timestamp).toLocaleDateString("process.env.APP_LOCALE".replace('_', '-'));
    let result = Object.entries(subscription.subscription_data).map(([key, value]) => transformer({ key, value }));
    const untilNextDate = t('active_until_next_date', {"$replace$": nextBillDate});
    if (isCancelled) {
        nextBillString = `<strong>${t('status_cancelled')}</strong>&nbsp; ${untilNextDate}`;
        // Show that the plan has been Cancelled.
        result = [
            {"key": t('billing_plan'), "value": t('status_cancelled'),},
            {"key": t('active_until'), "value": nextBillDate,},
        ];
    } else if (isFreeTrial) {
        nextBillString = `<strong>${t('status_trial')}</strong>&nbsp; ${untilNextDate}`;
        // Show that the plan has been Cancelled.
        result = [
            {"key": t('billing_plan'), "value": t('status_trial'),},
        ]
        if (subscription.id === "translator-free-credit") {
            result.push({"key": t('note'), "value": t('free_credit_thanks_note'),});
        }
        result.push({"key": t('active_until'), "value": nextBillDate,});
    } else if (frequency.toLowerCase() === "once") {
        isTimeBound = true;
        var expirationDate = new Date(subscription.subscription_data.expires).toLocaleDateString("process.env.APP_LOCALE".replace('_', '-'));
        nextBillString=t('active_until_next_date', {"$replace$": expirationDate});
        // setting nextBillDate for prevention, in case it's used somewhere in the UI we show the expiration
        // date of the license. It shouldn't be used anywhere if isTimeBound is true though
        nextBillDate = expirationDate;
        var amount_paid = (subscription.subscription_data.amount_cents / 100).toFixed(2);
        result = [
            { "key": t('billing_plan'), "value": frequency },
            { "key": t('active_until'), "value": expirationDate },
            { "key": "Paid Bill Amount", "value": amount_paid }
        ]
    } else {
        nextBillString = t('billing_plan_renews_on_date', {"$recurringFrequency$": fmtBillFrequency, "$nextBillDate$": nextBillDate});
    }
    return {
        subscription: result,
        nextBillDate: nextBillDate,
        nextBillString: nextBillString,
        isTimeBound
    };
};

module.exports = { processSubscription };
